import gql from 'graphql-tag'

const statsHomeLineChartAppuntamentiFissati = gql`
  query statsHomeLineChartAppuntamentiFissati($data: Date!) {
    statsHomeLineChartAppuntamentiFissati(data: $data) {
      numero
      data
    }
  }
`

export default statsHomeLineChartAppuntamentiFissati


// WEBPACK FOOTER //
// ./src/graphql/queries/statsHomeLineChartAppuntamentiFissati.js